var map = {
	"./en.json": [
		4174,
		990
	],
	"./id.json": [
		5176,
		236
	],
	"./km.json": [
		89,
		757
	],
	"./lo.json": [
		9540,
		484
	],
	"./my.json": [
		7243,
		839
	],
	"./th.json": [
		7549,
		121
	],
	"./vi.json": [
		1496,
		524
	],
	"./zh.json": [
		9527,
		883
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9842;
module.exports = webpackAsyncContext;